<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Notificaciones</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item active">Notificaciones</li>
            </ol>
        </div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-6">
                        <multi-select v-model="typeField" :options="typeFields" label="label" track-by="label"
                    placeholder="Seleccione un proveedor" @input="getNotifications(1)"/>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>Moastrar no leidos</label>
                            <input type="radio" value="0" v-model="status" @change="getNotifications(1)">
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>Moastrar leidos</label>
                            <input type="radio" value="1" v-model="status" @change="getNotifications(1)">
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="card-body">
                <table class="table table-responsive">
                    <thead>
                        <tr>
                            <th>Mensaje</th>
                            <th>Icono</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="notification in notifications" :key="notification.id">
                            <td v-text="notification.message"></td>
                            <td>
                                <i :class="'icon-fa '+notification.icon"/>
                            </td>
                            <td v-text="notification.created_at"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <ul class="pagination pagination-primary m-b-0">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a class="page-link" href="#"
                            @click.prevent="changePage(pagination.current_page - 1, search, critery)"><i
                                class="icon-fa icon-fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" v-for="page in pagesNumber" :key="page"
                        :class="[page == isActived ? 'active' : '']">
                        <a class="page-link" href="#" @click.prevent="changePage(page, search, critery)"
                            v-text="page"></a>
                    </li>
                    <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                        <a class="page-link" href="#"
                            @click.prevent="changePage(pagination.current_page + 1, search, critery)"><i
                                class="icon-fa icon-fa-angle-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    export default {
        components: {
            'multi-select': Multiselect,
        },
        computed: {
            isActived: function () {
                return this.pagination.current_page;
            },
            pagesNumber: function () {
                if (!this.pagination.to) {
                    return [];
                }
                var from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                var to = from + (this.offset * 2);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                var pagesArray = [];
                while (from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
        data() {
            return {
                status:0,
                pagination: {
                    'total': 0,
                    'current_page': 0,
                    'per_page': 0,
                    'last_page': 0,
                    'from': 0,
                    'to': 0,
                },
                offset: 3,
                typeField: {
                    label: 'Anulaciones',
                    value: 'icon-fa-ban'
                },
                typeFields: [
                    {
                        label: 'Anulaciones',
                        value: 'icon-fa-ban'
                    },
                    {
                        label: 'Faltas',
                        value: 'icon-fa-user-times'
                    },
                    {
                        label: 'Cuentas por pagar',
                        value: 'icon-fa-sign-out'
                    },
                    {
                        label: 'Cuentas por cobrar',
                        value: 'icon-fa-sign-in'
                    },
                    {
                        label: 'Traslados',
                        value: 'icon-fa-car'
                    },
                ],
                notifications: [],
                user: {}
            }
        },
        methods: {
            changePage(page, search, critery) {
                let me = this;
                me.pagination.current_page = page;
                me.getNotifications(page);
            },
            async getNotifications(page) {
                let vm = this;
                await axios.get(`/api/admin/notification?page=${page}&type=${vm.typeField.value}&status=${vm.status}`)
                    .then((response) => {
                        vm.notifications = response.data.notifications.data;
                        vm.pagination= response.data.pagination;
                    }).catch((error) => {
                        console.log(error);
                    })
            },
        },
        mounted(){
            this.getNotifications();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/notifications/Notification.vue